import React, { useState } from "react";
import {
	Box,
	FormControl,
	InputLabel,
	MenuItem,
	Select,
	SelectChangeEvent,
	Stack,
} from "@mui/material";
import QuotesTable from "../QuotesTable";
import { StatusNumber } from "../../helper/statusNumber";
import { MixpanelWrapper } from "../MixPanelWrapper";
import startCase from "lodash.startcase";
import QuoteFilter from "../QuoteFilter";

/**
 * Component for displaying a table of quotes with sorting options.
 *
 * @component
 * @param {Object} props - The component's props.
 * @param {number} props.quoteStatuses - An array of quote statuses to determine which quotes to display.
 */
const QuotesTableWrapper = ({ quoteStatuses, type } : { quoteStatuses?: number[], type?: string }) => {
	const [orderBy, setOrderBy] = useState<string>("modifiedDate");

	// We get all indexes from the StatusNumber enum in order to display all quotes
	const allQuoteStatuses = Object.keys(StatusNumber)
		.filter((i: any) => !isNaN(Number(i)))
		.map((i: any) => parseInt(i));

	const handleChange = (value: string) => {
		MixpanelWrapper.track("List Quotes", {
			Search: "",
			"Sort By": startCase(value),
		});
		setOrderBy(value);
	};

	return (
		<Stack>
			<Box width="100%" display="flex" justifyContent={"end"}>
				<QuoteFilter orderBy={orderBy} handleChange={handleChange} />
			</Box>
			<QuotesTable
				orderBy={orderBy}
				setOrderBy={setOrderBy}
				quoteStatuses={quoteStatuses ?? allQuoteStatuses}
                type={type}
			/>
		</Stack>
	);
};

export default QuotesTableWrapper;
